(function() {

  document.addEventListener('DOMContentLoaded', () => {
    // 監視するタイミング
    const options = {
      threshold: [0, 0.01, 0.99, 1]
    }

    // 監視時の挙動
    const $btn = document.getElementById('js-to-page-top');
    const $fl = $('#js-to-form').length;
    const $sl = $('#js-side-sns-list').length;
    const $toForm = document.getElementById('js-to-form');
    const $sideSnsList = document.getElementById('js-side-sns-list');
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {

        if(entry.intersectionRatio > 0) {
          // footerが見えている時
          $btn.classList.add('to-page-top-absolute');
          if ($fl) {
            $toForm.classList.add('to-form-absolute');
          }
          if ($sl) {
            $sideSnsList.classList.add('side-sns-list-absolute');
          }
        }else {
          // footerが見えていない時
          $btn.classList.remove('to-page-top-absolute');
          if ($fl) {
            $toForm.classList.remove('to-form-absolute');
          }
          if ($sl) {
            $sideSnsList.classList.remove('side-sns-list-absolute');
          }
        }
      });
    }, options);

    // 監視対象指定
    const watch = document.getElementById('footer');
    observer.observe(watch);
  });

})();